import React from 'react';
import { FileText } from 'lucide-react';
import Header from './components/Header19';
import Footer from './components/Footer19';

const TermsAndConditions = () => {
    const sections = [
        {
            title: '1. Acceptance of Terms',
            content: 'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.'
        },
        {
            title: '2. Use License',
            content: 'Permission is granted to temporarily download one copy of the materials (information or software) on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not: modify or copy the materials; use the materials for any commercial purpose; attempt to decompile or reverse engineer any software contained on our website; remove any copyright or other proprietary notations from the materials; or transfer the materials to another person or "mirror" the materials on any other server.'
        },
        {
            title: '3. Product Information',
            content: 'We strive to provide accurate product descriptions and imagery. However, we do not warrant that product descriptions, pricing, or other content on this site is accurate, complete, reliable, current, or error-free. Colors shown on your screen may vary from actual product colors due to monitor settings and limitations.'
        },
        {
            title: '4. Pricing and Payment',
            content: 'All prices are listed in the local currency and are subject to change without notice. We reserve the right to modify prices at any time. Payment must be received in full before orders are processed. We accept various payment methods as displayed during checkout. All payments are processed securely through encrypted connections.'
        },
        {
            title: '5. Order Acceptance',
            content: 'We reserve the right to refuse or cancel any order for any reason at any time. We may require additional information or verification before accepting any order. If your order is cancelled after your credit card has been charged, we will issue a credit to your account in the amount of the charge.'
        },
        {
            title: '6. Shipping and Delivery',
            content: 'We aim to dispatch all orders within the timeframe specified during checkout. Delivery times are estimates only and may vary. We are not responsible for delays caused by shipping carriers or customs. Risk of loss and title for items purchased pass to you upon delivery to the carrier.'
        },
        {
            title: '7. Returns and Refunds',
            content: 'Please review our Shipping & Returns policy for detailed information about returns, exchanges, and refunds. All returns must comply with our return policy requirements including timeframes and condition of items.'
        },
        {
            title: '8. Intellectual Property',
            content: 'All content included on this site, such as text, graphics, logos, images, and software, is our property or the property of our content suppliers and is protected by copyright laws. Unauthorized use of any materials may violate copyright, trademark, and other laws.'
        },
        {
            title: '9. User Account',
            content: 'If you create an account on our website, you are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account. We reserve the right to refuse service, terminate accounts, or cancel orders at our discretion.'
        },
        {
            title: '10. Limitation of Liability',
            content: 'In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we have been notified orally or in writing of the possibility of such damage.'
        },
        {
            title: '11. Privacy',
            content: 'Your use of our website is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices regarding the collection and use of your personal information.'
        },
        {
            title: '12. Governing Law',
            content: 'These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which we operate, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.'
        },
        {
            title: '13. Changes to Terms',
            content: 'We reserve the right to revise these terms and conditions at any time without notice. By using this website, you agree to be bound by the current version of these terms and conditions.'
        }
    ];

    return (
        <div className="min-h-screen bg-white">
            <Header />

            {/* Hero Section */}
            <section className="bg-gray-50 py-16 lg:py-20">
                <div className="container mx-auto px-4 lg:px-8 text-center">
                    <div className="w-16 h-16 bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-6">
                        <FileText className="w-8 h-8 text-white" />
                    </div>
                    <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
                        Terms & Conditions
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Please read these terms and conditions carefully before using our website
                    </p>
                    <p className="text-sm text-gray-500 mt-4">
                        Last Updated: January 2024
                    </p>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16 lg:py-20">
                <div className="container mx-auto px-4 lg:px-8">
                    <div className="max-w-4xl mx-auto">
                        <div className="space-y-8 lg:space-y-12">
                            {sections.map((section, index) => (
                                <div key={index} className="border-b border-gray-200 pb-8 lg:pb-12 last:border-0">
                                    <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 tracking-tight">
                                        {section.title}
                                    </h2>
                                    <p className="text-gray-600 leading-relaxed text-base lg:text-lg">
                                        {section.content}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {/* Contact Section */}
                        <div className="mt-12 lg:mt-16 p-6 lg:p-8 bg-gray-50 rounded-lg">
                            <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3 tracking-tight">
                                Questions About Our Terms?
                            </h3>
                            <p className="text-gray-600 mb-4 leading-relaxed">
                                If you have any questions about these Terms and Conditions, please contact us at:
                            </p>
                            <p className="text-gray-900 font-medium">
                                Email: legal@studio.com
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default TermsAndConditions;
